/**
 *
 * Notes: May, 2019
 * Original source code pulled (and edited) from previous website.
 * Assuming this was custom developed by previous vendor since license was not provided.
 *
 */

import $ from 'jquery';
import utils from './utils';

export default CostOfMortgage;

function CostOfMortgage (o) {

    let $container = $(o),
        $form = null,
        $principal = null,
        $interest = null,
        $term = null,
        $mortgage = null,
        $monthly = null;


    $form = $container.find("form");
    $principal = $form.find("input[name=principal]");
    $interest = $form.find("input[name=interest]");
    $term = $form.find("input[name=term]");

    $mortgage = $form.find("input[name=mortgage]");
    $monthly = $form.find("input[name=monthly]");

    $form.submit(function(e) {
        $form.find('.calc-results').removeClass('hidden');
        let P = Number($principal.val().replace("$","")),
            r = Number($interest.val().replace("%", ""))/100,
            t = Number($term.val());

        $mortgage.val(utils.cost(P, r, 4, t).toFixed(2));
        $monthly.val(utils.pmt(P, r, 12, t).toFixed(2));
        $mortgage.currency();
        $monthly.currency();

        e.preventDefault();
        return false;

    });

    $container.find("button[type='reset']").on('click',function(){
        $('.calc-results').addClass('hidden');
        $principal.focus();
    });

}


// WEBPACK FOOTER //
// ./src/calculators/cost-of-mortgage.js